export const model = {
  id: null,
  trackable_type: '',
  created_at: '',
  updated_at: '',
};
